import { CapitalStructureBuildStructureDto } from '@app/shared/models/contracts/capital-structure-debt-instrument-dto';
import { CapitalStructureEventSeverity } from '@app/shared/models/contracts/enums/shared-enums';

export const useCapitalStructureFaults = (
  buildStructure: CapitalStructureBuildStructureDto,
  capitalStructureEventId: string,
  eventSetId: string
) => {
  const informationFaults = buildStructure.faults.filter(
    (fault) =>
      fault.severity === CapitalStructureEventSeverity.Information &&
      fault.event === capitalStructureEventId &&
      (fault.eventSet === null || fault.eventSet === eventSetId)
  );

  const warningFaults = buildStructure.faults.filter(
    (fault) =>
      fault.severity === CapitalStructureEventSeverity.Warning &&
      fault.event === capitalStructureEventId &&
      (fault.eventSet === null || fault.eventSet === eventSetId)
  );

  const errorFaults = buildStructure.faults.filter(
    (fault) =>
      fault.severity === CapitalStructureEventSeverity.Error &&
      fault.event === capitalStructureEventId &&
      (fault.eventSet === null || fault.eventSet === eventSetId)
  );

  return {
    informationFaults,
    warningFaults,
    errorFaults,
  };
};
